export const leftItems = [
  {
    id: 1,
    title: "Self-Directed Trading Apps",
    img: require("../../../image/stocktrading/type-img-one.webp"),
  },
  {
    id: 1,
    title: "Robo-Advisors",
    img: require("../../../image/stocktrading/type-img-two.webp"),
  },
  {
    id: 1,
    title: "Full-Service Brokerage Apps",
    img: require("../../../image/stocktrading/type-img-three.webp"),
  },
  {
    id: 1,
    title: "Social Trading Platforms",
    img: require("../../../image/stocktrading/type-img-four.webp"),
  },
];

export const typeRightData = [
  "These apps empower users to trade stocks independently. Stock trading app development for this category focuses on user autonomy and decision-making tools.",
  "Stock trading app development for robo-advisors integrates AI-driven solutions to provide automated investment advice and portfolio management.",
  "These apps offer comprehensive services, including personalized advice and in-depth market research. Stock trading app development in this category targets experienced traders.",
  "Social trading apps enable users to follow and replicate successful traders' strategies. Stock trading app development for these platforms emphasizes community features.",
];
